import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHailuo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_17396_28180)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M20 10C20 4.47753 15.5 -0.0141332 9.97503 3.34193e-05C4.4917 0.0142001 0.0125334 4.4917 3.34193e-05 9.97503C-0.0141332 15.5 4.47753 20 10 20H16.5709C17.4788 20 18.3495 19.6394 18.9915 18.9974C19.6335 18.3554 19.9942 17.4846 19.9942 16.5767V10.3334C19.9975 10.2225 20 10.1117 20 10ZM4.85753 15.5534C3.26587 14.195 2.2842 12.02 2.33003 9.80337C2.33337 9.64837 2.34087 9.49337 2.35503 9.33837V9.32837C2.58587 6.68337 4.2942 4.2167 6.68837 3.07087C9.08337 1.92503 12.0767 2.1442 14.28 3.6242C16.4834 5.10503 17.8159 7.7942 17.66 10.4442C17.6215 11.0245 17.5298 11.5999 17.3859 12.1634C17.3309 12.3884 17.2634 12.6209 17.1042 12.7884C16.9459 12.9559 16.6675 13.0342 16.4792 12.9C16.2992 12.7717 16.2725 12.52 16.2575 12.3C16.1325 10.5217 15.6575 8.68753 14.4559 7.37087C13.5319 6.37131 12.2718 5.74762 10.9167 5.6192C9.56167 5.50204 8.20927 5.87198 7.10253 6.66253C6.1867 7.31837 5.46753 8.25753 5.1192 9.3292C4.77253 10.4 4.80753 11.6009 5.26503 12.6309C5.60406 13.3913 6.15342 14.039 6.84837 14.4975C8.07087 15.3 9.7442 15.4142 11.015 14.6892C12.285 13.9642 13.0442 12.3909 12.7209 10.9642C12.3967 9.53753 10.9509 8.42503 9.49587 8.57587C9.2742 8.59837 8.95587 8.5742 8.94837 8.35087C8.9417 8.17837 9.1492 8.08753 9.3192 8.0567C10.795 7.7917 12.3775 8.5417 13.1859 9.8042C13.9967 11.0667 14.0375 12.7575 13.3767 14.1042C12.715 15.45 11.4017 16.4334 9.94503 16.7884C7.98087 17.2675 6.20253 16.7009 4.8592 15.5534H4.85753Z",
				fill: "url(#paint0_linear_17396_28180)"
			})
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_17396_28180",
			x1: .4492,
			y1: .7367,
			x2: 22.9059,
			y2: 22.5184,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .09,
					stopColor: "#FFAB0C"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .31,
					stopColor: "#FF5538"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .46,
					stopColor: "#E9405D"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .75,
					stopColor: "#D266DA"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .89,
					stopColor: "#D584EF"
				})
			]
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_17396_28180",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white"
			})
		})] })
	]
});
const ForwardRef = forwardRef(SvgHailuo);
export default ForwardRef;
